<template>
    <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7179_12114)">
    <path d="M16.3284 2.58072C15.8093 2.06164 14.9603 2.06164 14.4412 2.58072L5.76885 11.252L2.48207 11.3567L2.20508 12.5221L4.29605 14.6131L6.38702 16.7041L7.55242 16.4271L7.65714 13.1403L16.3284 4.46788C16.8475 3.9488 16.8475 3.0998 16.3284 2.58072Z" stroke="var(--primary-blue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.48945 8.52808L11.5431 5.47438L3.77942 3.83719C3.49905 3.78202 3.19728 3.86196 2.97996 4.07928C2.63428 4.42496 2.63428 4.9857 2.97996 5.33138C3.03063 5.38205 3.08693 5.42484 3.14661 5.46087L8.49058 8.52808H8.48945Z" stroke="var(--primary-blue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.0678 15.1281L13.4306 7.36328L10.377 10.417L13.443 15.7609C13.4791 15.8195 13.5219 15.8758 13.5725 15.9276C13.9182 16.2733 14.4789 16.2733 14.8246 15.9276C15.0419 15.7103 15.1219 15.4085 15.0667 15.1281H15.0678Z" stroke="var(--primary-blue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_7179_12114">
    <rect width="17" height="17" fill="white" transform="translate(0.960938 0.945312)"/>
    </clipPath>
    </defs>
    </svg>
    
    
      </template>
      
      <script setup></script>
      
